import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';

import { get } from 'lodash';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const MultiSelect = ({
  label,
  name,
  options = [],
  placeholder,
  ...rest
}) => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  const errorMessage = get(errors, name)?.message;

  return (
    <FormControl isInvalid={errorMessage}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value, ref } }) => (
          <Select
            inputRef={ref}
            placeholder={placeholder ?? ''}
            value={value}
            onChange={onChange}
            options={options}
            inputId={name}
            isMulti
            {...rest}
          />
        )}
      />
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
};

export default MultiSelect;
